import { render, staticRenderFns } from "./erp.vue?vue&type=template&id=d3860bb6&"
import script from "./erp.vue?vue&type=script&lang=js&"
export * from "./erp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports